/** Backend bid-type tokens, mapped to the labels the bid editor already translates. */
export const BID_TYPE_ALERT_KEY_BY_TOKEN: Record<string, string> = {
  blockbid: 'Block bid',
  profilebid: 'Profile bid',
}
